import { createAsyncThunk } from '@reduxjs/toolkit';
import { batch } from 'react-redux';

import { updateMyDriver } from '@/modules/driver/actions/actions';
import { updatePartner } from '@/modules/partner/actions/actions';
import { ThunkResult } from '@/shared/actions/thunk-result';
import { formatAddress } from '@/shared/utils/formatAddress';

import { onboardingAPI, ISubmitFormResult } from '../api';
import { IHelloForm } from '../model/helloStep';
import { isStepAccepted } from '../model/stepErrors';
import { namespace } from '../namespace';

let lastRequestId: string | undefined;

const submitHelloStep = createAsyncThunk(
  `${namespace}/submit-hello-step`,
  async (
    formValues: IHelloForm,
    { dispatch, requestId },
  ): Promise<ThunkResult<ISubmitFormResult<IHelloForm>>> => {
    try {
      if (lastRequestId !== undefined) {
        return { isAlreadyExecuted: true };
      }

      lastRequestId = requestId;

      const result = await onboardingAPI.submitHelloStep(formValues);

      if (isStepAccepted(result)) {
        const {
          personalInn,
          homeAddressLine1,
          homeAddressLine2,
          homeAddressCity,
          homeAddressState,
          homeAddressPostcode,
          ...driverFields
        } = formValues;
        const homeAddress = formatAddress(formValues);

        batch(() => {
          dispatch(updateMyDriver({ ...driverFields, homeAddress }));
          dispatch(updatePartner({ personalInn, onboarding: result.onboarding }));
        });
      }

      return {
        isSucceed: true,
        result,
      };
    } finally {
      lastRequestId = undefined;
    }
  },
);

export { submitHelloStep };
